import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsMenuModule,
} from '@cmps/ng-uikit';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

import { CmpsCoachingTagsModule } from '../coaching-tags/coaching-tags.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { NoteDetailComponent } from './note-detail.component';
import { NotesComponent } from './notes.component';
import { TranslationIdMap } from './notes.i18n';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectModule,
        EditorModule,
        CmpsButtonModule,
        CmpsIconModule,
        CmpsMenuModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCoachingTagsModule,
    ],
    declarations: [NoteDetailComponent, NotesComponent],
    exports: [NoteDetailComponent, NotesComponent],
    providers: [
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }, // TODO cache busting
    ],
})
export class CmpsNoteModule {}
